var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"py-1 px-0"},[_c('v-card-text',{staticClass:"law-text",domProps:{"innerHTML":_vm._s(_vm.lawText)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }